import { getContext } from '@fiverr-private/fiverr_context';
import { useRolloutsContext } from '../../../../../../GigCardListings/context/RolloutsContext/RolloutsContext';
import { EXPERIMENTS, ROLLOUTS } from '../../../../../../constants/experiments';

export const useShouldShowLabelToTheRight = () => {
    const { abTests = {}, experience, isTouch } = getContext();
    const { rollouts } = useRolloutsContext();

    const isInRollout = rollouts[ROLLOUTS.BULLS_MOVE_AD_LABEL_TO_RIGHT];

    const isEligible = !experience?.isBusiness && !isTouch;

    if (!isEligible || !isInRollout) {
        return false;
    }

    const existingGroup = abTests[EXPERIMENTS.BULLS_MOVE_AD_LABEL_TO_RIGHT_EXPERIMENT];
    return Number(existingGroup) > 1;
};
